import React from "react";
import { selectionpng } from "../../../assets";

interface ExistsOwnMemberModelProps {
	onClose: () => void;
	dependentData: any[]; // Ensure it's an array
}

const ExistsDependentModelVEB: React.FC<ExistsOwnMemberModelProps> = ({ onClose, dependentData }) => {
	// console.log("DEPENDENTDATA------>", dependentData);
	return (
		<div
			style={{
				position: "fixed",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: "rgba(0, 0, 0, 0.7)",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				zIndex: 1000
			}}
		>
			<div
				style={{
					backgroundColor: "#ffffff",
					padding: "30px",
					borderRadius: "12px",
					boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
					maxWidth: "500px",
					width: "90%",
					textAlign: "center",
					position: "relative"
				}}
			>
				{/* Close Button */}
				<button
					style={{
						position: "absolute",
						top: "15px",
						right: "15px",
						backgroundColor: "transparent",
						border: "none",
						fontSize: "1.5rem",
						cursor: "pointer",
						color: "#666"
					}}
					onClick={onClose}
				>
					&times;
				</button>

				{/* Icon */}
				<img
					src={selectionpng}
					alt="Duplicate SSN"
					style={{
						width: "100px",
						height: "100px",
						marginBottom: "20px"
					}}
				/>

				{/* Title */}
				<h2
					style={{
						marginBottom: "20px",
						fontSize: "1.75rem",
						color: "#333",
						fontWeight: "700"
					}}
				>
					Attention!
				</h2>

				{/* Map through dependentData */}
				{dependentData?.length > 0 ? (
					<div>
						{dependentData.map((dependent, index) => (
							<span
								key={index}
								style={{
									backgroundColor: "#fff3cd",
									padding: "2px 6px",
									borderRadius: "4px",
									fontWeight: "600",
									color: "#856404",
									marginRight: "5px" // Optional: Add spacing between dependents
								}}
							>
								{dependent?.first_name} {dependent?.last_name}{" "}
								<span
									style={{
										color: "oklch(0.505 0.213 27.518)", // Green color for the relationship
										fontWeight: "600"
									}}
								>
									({dependent?.relationship ?? "Employee"})
								</span>
							</span>
						))}

						<p
							style={{
								marginBottom: "15px",
								fontSize: "1rem",
								color: "#495057",
								lineHeight: "1.6",
								marginTop: "10px" // Optional: Add spacing between the names and the text
							}}
						>
							{dependentData.length > 1
								? "The above dependents are already covered in this benefit plan. Please note that you will not be able to claim benefits for these dependents."
								: "One of your dependents is already covered in this benefit plan. Please note that you will not be able to claim benefits for this dependent."}
						</p>
					</div>
				) : (
					<p>No dependents found.</p>
				)}

				{/* Highlighted Note Section */}
				<div
					style={{
						backgroundColor: "#fff3cd",
						padding: "15px",
						borderRadius: "8px",
						marginBottom: "25px",
						borderLeft: "4px solid #ffc107"
					}}
				>
					<p
						style={{
							margin: 0,
							fontSize: "0.95rem",
							color: "#856404",
							lineHeight: "1.5"
						}}
					>
						<strong>Note:</strong> If you believe this is an error, please contact your HR department for
						assistance.
					</p>
				</div>

				{/* Close Button */}
				<button
					style={{
						backgroundColor: "#000000",
						color: "#ffffff",
						border: "none",
						padding: "12px 30px",
						borderRadius: "6px",
						cursor: "pointer",
						fontSize: "1rem",
						fontWeight: "600",
						transition: "background-color 0.3s ease"
					}}
					onClick={onClose}
					//eslint-disable-next-line
					onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#333333")}
					//eslint-disable-next-line
					onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#000000")}
				>
					Close
				</button>
			</div>
		</div>
	);
};

export default ExistsDependentModelVEB;
